import { z } from 'zod';
import { applicationFeaturesSchema, assetsInfoSchema, authMethodSchema } from './configuration.schema';

export const applicationStatusSchema = z.enum(['ready', 'inProgress', 'failed']);

export const applicationVersionSchema = z.enum(['v1', 'v2']);

export const applicationSchema = z.object({
    apiKey: z.string(),
    createdAt: z.number(),
    name: z.string(),
    identifier: z.string(),
    description: z.string(),
    status: applicationStatusSchema,
    accessCode: z.string(),
    adminId: z.string().optional(),
    splashURL: z.string(),
    avatarURL: z.string(),
    bannerURL: z.string(),
    iconName: z.string(),
    version: applicationVersionSchema,
    assetsInfo: assetsInfoSchema.optional(),
    membersLimit: z.number(),
    membersCount: z.number(),
    billableAssetsLimit: z.number().optional(),
    billableAssetsCount: z.number().optional(),
    invitationsCount: z.number(),
    authMethods: z.array(authMethodSchema),
    availableAuthMethods: z.array(authMethodSchema).optional(),
    features: applicationFeaturesSchema,
});

export type Application = z.infer<typeof applicationSchema>;
export type ApplicationStatus = z.infer<typeof applicationStatusSchema>;
export type ApplicationVersion = z.infer<typeof applicationVersionSchema>;
